import Group from '@/classes/v2/Group';

const setCurrentUserGroups = (state, rawGroups) => {
  state.currentUserGroups = rawGroups.map(rawGroup => new Group(rawGroup));
};

const setEnterpriseGroups = (state, rawGroups) => {
  state.enterpriseGroups = rawGroups.map(rawGroup => new Group(rawGroup));
};

const addUserGroup = (state, rawGroup) => {
  state.currentUserGroups.push(new Group(rawGroup));
};

const editUserGroup = (state, rawGroup) => {
  const updatedGroup = new Group(rawGroup);
  const index = state.currentUserGroups.findIndex(
    group => group.id === updatedGroup.id
  );
  if (index !== -1) {
    state.currentUserGroups.splice(index, 1, updatedGroup);
  }
};

const deleteUserGroup = (state, groupId) => {
  const index = state.currentUserGroups.findIndex(group => group.id === groupId);
  if (index !== -1) {
    state.currentUserGroups.splice(index, 1);
  }
};

const removeContactFromAllGroups = (state, contact) => {
  state.currentUserGroups.forEach(group => {
    if (group.contactsNumbers.includes(contact.number)) {
      group.contactsNumbers = group.contactsNumbers.filter(id => id !== contact.number);
    }
  });
};

export default {
  addUserGroup,
  editUserGroup,
  deleteUserGroup,
  removeContactFromAllGroups,
  setCurrentUserGroups,
  setEnterpriseGroups
};
